import React, {Component} from 'react';
import ModalUploadFilm from '../../components/modals/ModalUploadFilm';

import {t} from 'l10n';

import 'sass/headers/HeaderMemberAmateurFilms.scss';

class HeaderMemberAmateurFilms extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        }
    }

    render() {
        let {onUploadFilmSuccess} = this.props;

        let {showModal} = this.state;

        let editFilm = false;

        return (
            <header className="profile-header-brief myamateurfilms">
                <div className="content">
                    <h1>{t('My amateur videos')}</h1>
                    <div className="text-header-myamateurfilms">
                        <div />

                        <ModalUploadFilm
                            editFilm={editFilm}
                            show={showModal}
                            closeFn={() => this.setState({showModal: false})}
                            onSuccess={onUploadFilmSuccess}
                        />

                        <div>
                            <div className="upload-film-button" onClick={() => this.setState({showModal: true})}>{t('Publish a video')}</div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderMemberAmateurFilms;


// WEBPACK FOOTER //
// ./src/components/member/HeaderMemberAmateurFilms.js